module.exports = __webpack_public_path__ + "static/media/citron-mobiles-1-tiny.4e0bf5ad.jpg";